import { generateGrid } from '#src/services/grid'

const defaultGrid = generateGrid([
  {
    title: 2
  },
  {
    featured: 2
  }
])

const smallGrid = generateGrid([
  {
    featured: 4,
    title: 4
  },
  {
    featured: 4,
    list: 4
  }
])

const mediumGrid = generateGrid([
  {
    featured: 4,
    title: 8
  },
  {
    featured: 4,
    list: 8
  }
])

const largeGrid = generateGrid([
  {
    featured: 4,
    title: 8
  },
  {
    featured: 4,
    list: 8
  }
])

export default { defaultGrid, smallGrid, mediumGrid, largeGrid }
